/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';
import React from 'react';
import FormularioTiposDivisionesCV from './controladorVista/formularioTiposDivisionesCV';
import TablaTiposDivisionesCV from './controladorVista/tablaTiposDivisionesCV';
import { estadoIncial, reductor } from './reductorTiposDivisiones';

const TiposDivisiones: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaTiposDivisionesCV />
        <FormularioTiposDivisionesCV />
    </ProveedorEstado>
);

export default TiposDivisiones;
